import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

export interface StatItem {
  label: string;
  value: string | number;
  color?: string;
  className?: string;
}

interface StatsSummaryProps {
  stats: StatItem[];
  compact?: boolean;
}

/**
 * A reusable component for displaying summary statistics
 */
const StatsSummary: React.FC<StatsSummaryProps> = ({
  stats,
  compact = true,
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: compact ? 1 : 2,
        mt: 2,
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        gap: 3,
        borderRadius: 1,
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      {stats.map((stat, index) => (
        <Box
          key={index}
          className={`stat-item ${stat.className || ''}`}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontWeight: 'medium' }}
          >
            {stat.label}:
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 'bold',
              color: stat.color || 'text.primary',
            }}
          >
            {stat.value}
          </Typography>
        </Box>
      ))}
    </Paper>
  );
};

export default StatsSummary;
